.list {
  --ixf-list-item-height: 48px;

  .loader {
    height: var(--ixf-list-item-height);
    width: 100%;
  }
}
